import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 15px 0px;
  @media (max-width: 768px) {
    flex-direction: ${props => props.resumeView ? 'row' : 'column'};
    align-items: center;
    margin: ${props => props.resumeView ? '15px' : '15px 0px'};
    margin: 15px;
    width: calc(100% - 30px);
  }
`;

const Title = styled.h3`
  color: #B6936C;
`;

const P = styled.p`
  color: ${props => props.color ? props.color : '#B6936C'};
  margin: ${props => props.margin ? props.margin : null};
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : null};
  font-size: ${props => props.fontSize ? props.fontSize : null};
  white-space: ${props => props.nowrap ? 'nowrap' : null};
  text-align: ${props => props.center ? 'center' : null};
  font-weight: ${props => props.bold ? 'bold' : null};
  @media (max-width: 768px) {
    display: ${props => props.hideMobile ? 'none' : 'block'};
  }
`;

const Select = styled.select`
  border: 1px solid #B6936C;
  border-radius: 3px;
  background-color: white;
  color: #B6936C;
  padding: 5px 10px;
  width: 300px;
  @media (max-width: 1100px) {
    width: 250px;
  }
  @media (max-width: 768px) {
    width: ${props => props.small ? '120px' : '220px'};
    font-size: 14px;
  }
`;

const Price = styled.p`
  border: 1px solid #B6936C;
  border-radius: 3px;
  background-color: #B6936C;
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 3px 5px;
`;

const Desc = styled.p`
  font-size: 12px;
  color: ${props => props.color ? props.color : '#8B8B8B'};
  max-width: 350px;
`;

const Content = styled.div`
  margin-left: 60px;

  @media (max-width: 900px) {
    margin-left: 0px;
  }

  @media (max-width: 768px) {
    margin-top: 10px;
    max-width: 320px;
    padding: 4px;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  @media (max-width: 768px) {
    margin-left: 20px;
  }
`;

const InnerContent = styled.div`
  display: flex;
  margin-top: 20px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Separator = styled.div`
  width: 120px;
  border: 2px solid #C1A886;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
`;

const MobileContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const MobileDescription = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    background-color: #B79671;
    border-radius: 3px;
    padding: 15px;
  }
`;

const ResumeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 40px;
  margin-right: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 20px;
    margin-right: 0px;
  }
`;

const ShowMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const HideMobile = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Button = styled.button`
  border: 2px solid #B89976;
  border-radius: 3px;
  color: ${props => props.main ? 'white' : '#B89976'};
  background-color: ${props => props.main ? '#B89976' : 'white'};
  font-weight: bold;
  padding: 8px 35px;
  text-transform: uppercase;
  margin-left: ${props => props.marginLeft ? props.marginLeft : null};
  margin-right: ${props => props.marginRight ? props.marginRight : null};
  @media (max-width: 768px) {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 10px;
    width: 100%;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ModalP = styled.p`
  font-size: 15px;
  color: ${props => props.color ? props.color : null};
  text-align: ${props => props.center ? 'center' : 'left'};
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ModalTitle = styled.h2`
  font-size: 26px;
  text-transform: uppercase;
  font-weight: bold;
  color: #B89976;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 18px;
    text-align: center;
  }
`;

const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column; 
  margin-right: 60px;

  @media (max-width: 850px) {
    margin-right: 20px;
  }

`

const Chip = styled.div`
  color: rgb(182, 147, 108);
  border: none;
  cursor: default;
  height: 28px;
  display: inline-flex;
  outline: 0;
  padding: 0;
  font-size: 0.8125rem;
  box-sizing: border-box;
  transition: background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  align-items: center;
  white-space: nowrap;
  border-radius: 16px;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  background-color: rgb(250, 250, 250);
  box-shadow: 1px 3px 6px rgba(0,0,0,0.16);
  margin: 0 4px 1rem 4px;
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 12px;
  text-overflow: ellipsis;
  position: absolute;
  top: 12px;
  right: 5px;
`

export {
  Container,
  Title,
  P,
  Select,
  Price,
  Desc,
  Content,
  PriceContainer,
  InnerContent,
  Separator,
  MobileContainer,
  MobileDescription,
  ResumeContainer,
  ShowMobile,
  HideMobile,
  Button,
  ButtonsContainer,
  ModalP,
  ModalTitle,
  SelectorContainer,
  Chip
};